<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 overflow-auto bg-black/50 flex items-center justify-center"
  >
    <div class="bg-base-100 rounded-lg shadow-xl max-w-md w-full m-4">
      <!-- Modal header -->
      <div class="flex justify-between items-center p-4 border-b">
        <h3 class="text-lg font-medium">Keleivis natvyko</h3>
        <button @click="closeModal" class="text-base-content/60 hover:text-base-content/80">
          <span class="sr-only">Uždaryti</span>
          <svg
            class="h-6 w-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <!-- Modal content -->
      <div class="p-4">
        <div v-if="isLoading" class="py-8 text-center">
          <span class="loading loading-spinner loading-lg text-base-content/60"></span>
        </div>

        <div v-else>
          <div class="mb-6">
            <h1 class="font-semibold mb-2">Pavėžėjimas:</h1>
            <div class="mb-2">
              <div class="text-sm text-base-content/60">Pradžia</div>
              <div>
                {{ tripInfo.waypoints[0].time }} -
                {{ tripInfo.waypoints[0].address }}
              </div>
            </div>
            <div>
              <div class="text-sm text-base-content/60">Pabaiga</div>
              <div>
                {{ tripInfo.waypoints[1].time }} -
                {{ tripInfo.waypoints[1].address }}
              </div>
            </div>
          </div>

          <div v-if="tripInfo.passengers && tripInfo.passengers.length > 0">
            <!-- List of passengers -->
            <h1 class="font-semibold mb-2">Vairuotojo žinutė:</h1>
            <textarea
              v-model="driverNotice"
              class="textarea w-full"
            ></textarea>
          </div>
          <div v-else class="py-4 text-center text-base-content/60">
            Keleivių informacija nerasta
          </div>
        </div>
      </div>

      <!-- Modal footer -->
      <div class="border-t p-4 flex justify-between">
        <button
          @click="updateTrip"
          class="btn btn-error"
          :disabled="isSubmitting"
        >
          Neatvyko
        </button>
        <button @click="closeModal" class="btn" :disabled="isSubmitting">
          Uždaryti
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import { useTripStore } from "@/stores/trips";
// import DefaultIcon from "@/components/icons/DefaultIcon.vue";

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  tripId: {
    type: [Number, String],
    default: null,
  },
});

const emit = defineEmits(["close"]);

const tripsStore = useTripStore();
const isLoading = ref(false);
const isSubmitting = ref(false);
const tripInfo = ref(null);
const driverNotice = ref("");

const fetchTripInfo = async () => {
  if (!props.tripId) return;

  isLoading.value = true;

  try {
    const tripData = await tripsStore.fetchTripById(props.tripId);
    tripInfo.value =
      tripData.passengers && tripData.passengers.length > 0 ? tripData : null;
  } catch (error) {
    console.error("Failed to fetch passenger info:", error);
    tripInfo.value = null;
  } finally {
    isLoading.value = false;
  }
};

const closeModal = () => {
  driverNotice.value = "";
  emit("close");
};

// Fetch passenger info when modal opens
watch(
  () => props.isOpen,
  (newValue) => {
    if (newValue && props.tripId) {
      fetchTripInfo();
    } else {
      tripInfo.value = null;
      driverNotice.value = "";
    }
  },
  { immediate: true },
);

const updateTrip = async () => {
  if (!props.tripId) return;

  isSubmitting.value = true;

  try {
    const updatedTrip = await tripsStore.passengerNotArrived(
      props.tripId,
      driverNotice.value,
    );

    // Emit event to notify parent that trip was updated
    emit("updated", updatedTrip);

    // Close the modal
    closeModal();
  } catch (error) {
    console.error("Failed to update trip:", error);
    // You might want to show an error message to the user
  } finally {
    isSubmitting.value = false;
  }
};
</script>
